import React, { Component } from 'react';
import Tablec from 'components/Tablec';
import './index.styl';

const clzpre = 'sensor-table';
const columns = [
    {
        name: '名称',
        key: 'name'
    },
    {
        name: '湿度',
        key: 'humidity'
    },
    {
        name: '外接温度1',
        key: 'outSideTemperature1'
    },
    {
        name: '外接温度2',
        key: 'outSideTemperature2'
    },
    {
        name: '温度',
        key: 'temperature',
        render: v => {
            const clz = v < 0 ? 'error' : '';
            return <span className={clz}>{v}</span>;
        }
    },
    {
        name: '状态',
        key: 'status',
        render: v => {
            let clz = 'normal';
            let text = '正常';
            switch (v) {
                case 3:
                    clz = 'error';
                    text = '报警';
                    break;
                case 2:
                    clz = 'warning';
                    text = '警告';
                    break;
                default:
            }
            return <span className={`${clzpre}-status ${clz}`}>{text}</span>;
        }
    }
];

class TableView extends Component {
    filterData = tds => {
        const { value } = this.props;
        if (!value) {
            return tds;
        }
        return tds.filter(d => {
            let flag = false;
            for (let k in d) {
                if (d[k] && d[k].toString().indexOf(value) > -1) {
                    flag = true;
                    break;
                }
            }
            return flag;
        });
    };

    render() {
        const { data } = this.props;
        const props = { columns, data, styleType: 'SHADOW_HEADER' };
        return (
            <div className={clzpre}>
                <Tablec {...props} filter={this.filterData} />
            </div>
        );
    }
}

export default TableView;
